// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"K3-z","colorTextValue":"L3-z","swatches":"M3-z","collapseLink":"N3-z","isCollapsed":"O3-z","dropdown":"P3-z","disabled":"Q3-z"};